/**
 * Auth module service layer.
 *
 * Wraps the API calls in `authApi.js` with business logic + user-friendly
 * error messages. Pages should call these instead of hitting the API
 * directly so retry / validation / mapping live in one place.
 */
import * as authApi from "@/modules/Auth/api/authApi.js";

const friendly = (error, fallback) =>
  error?.response?.data?.message || error?.message || fallback;

export const signInWithPassword = async (username, password) => {
  try {
    return await authApi.postSignIn(username, password);
  } catch (error) {
    throw new Error(friendly(error, "Sign-in failed. Please check your email and password."));
  }
};

export const signInWithGoogleCredential = async (googleToken) => {
  try {
    return await authApi.postSignInWithGoogle(googleToken);
  } catch (error) {
    throw new Error(friendly(error, "Google sign-in failed."));
  }
};

export const fetchGoogleProfilePrefill = async (googleToken) => {
  try {
    return await authApi.postSignInWithGoogleData(googleToken);
  } catch (error) {
    throw new Error(friendly(error, "Could not load Google profile."));
  }
};

export const signupInsured = async (payload) => {
  try {
    return await authApi.postInsuredSignup(payload);
  } catch (error) {
    throw new Error(friendly(error, "Sign-up failed. Please try again."));
  }
};

export const signOut = async () => {
  await authApi.postLogout();
};

export const restoreSession = async () => authApi.fetchInsuredSession();

export const loadGoogleClientId = async (opts) => {
  try {
    return await authApi.fetchGoogleClientId(opts);
  } catch (error) {
    throw new Error(friendly(error, "Google sign-in is unavailable right now."));
  }
};
